import { ApiMask, updateApiMask } from '../../../logger/BitMask';
import { Fetcher } from '../../Fetcher';

import { mainTableConfigParser } from './parser';
import { jspTableConfigParser } from './parserJsp';
import type { IServerTableConfigResponse, ITableConfigParserOptions, TableConfigType } from './types';

export interface IFetchTableConfigParams {
  baseUrl: string;
  parserOptions: ITableConfigParserOptions;
  params: any;
}

// Use JSP or JSON API fetcher based on ENDPOINT_TABLE_CONFIG value in manifest
export const fetchTableConfig = (params: IFetchTableConfigParams): Promise<TableConfigType> => {
  return ENDPOINT_TABLE_CONFIG === 'jsp' ? fetchTableConfigJsp(params) : fetchTableConfigJson(params);
};

const fetchTableConfigJsp = ({ baseUrl, params, parserOptions }: IFetchTableConfigParams): Promise<TableConfigType> => {
  const url = `${baseUrl}/cgibin/tableconfig.jsp`;
  const jspFetchParams = { JSESSIONID: params.JSESSIONID, table_id: params.tableId }; // todo: investigate why other games include 'ck' and 'game_mode' params

  return Fetcher.fetch<string>(url, { params: jspFetchParams, format: 'text' })
    .then((response) => jspTableConfigParser({ resResult: response, parseBetLimits: parserOptions.parseBetLimits }))
    .then((parsedResponse) => {
      updateApiMask(ApiMask.TableConfig);
      return parsedResponse;
    });
};

const fetchTableConfigJson = ({
  baseUrl,
  params,
  parserOptions,
}: IFetchTableConfigParams): Promise<TableConfigType> => {
  const url = `${baseUrl}/api/ui/tableConfig`;

  return Fetcher.fetch<IServerTableConfigResponse | { errorCode: string | number; description: string }>(url, {
    params,
  })
    .then((response) => {
      if ('description' in response || 'errorCode' in response) {
        throw new Error(response.description || response.errorCode.toString());
      }

      return mainTableConfigParser({
        resResult: response as IServerTableConfigResponse,
        parseBetLimits: parserOptions.parseBetLimits,
      });
    })
    .then((parsedResponse) => {
      updateApiMask(ApiMask.TableConfig);
      return parsedResponse;
    });
};
